import { Directive, HostBinding, Input, HostListener, ElementRef } from '@angular/core';
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";

@Directive({
    standalone: false,
    selector: '[clickHighlight]'
})
export class ClickHighlightDirective {

    constructor(private doms: DomSanitizer, private el: ElementRef) { }

    @HostListener('click') onClick() {
        const cell = this.el.nativeElement;
        const cellSelected = cell.className === 'single-cell' ? cell?.parentNode.parentNode : cell;
        const isNodeSelected = cellSelected?.className?.indexOf('bg-blue') === -1;
        cellSelected?.classList?.[isNodeSelected ? 'add' : 'remove']('bg-blue');
    }
}